module.exports = __webpack_public_path__ + "img/icon2.a8795a11.png";